import React from "react";
import { Line } from "react-chartjs-2";

const defaultOptionsLine = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: true,
            position: 'top'
        },
        tooltip: {
            mode: 'index',
            intersect: false,
        }
    },
    scales: {
        x: {
            grid: {
                display: true
            },
            ticks: {
                maxTicksLimit: 10,
                maxRotation: 45,
                minRotation: 0
            }
        },
        y: {
            beginAtZero: true,
            grid: {
                display: true
            }
        }
    },
    interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false
    }
}

export default function ChartsLine(props) {
    const options = props.options ? { ...defaultOptionsLine, ...props.options } : defaultOptionsLine;

    return (
        <Line data={props.data} options={options} />
    )
}